module.exports = __webpack_public_path__ + "static/c4-9c1d366adce37d18d9a89abf60c21c6c.jpg";